<template>
  <div class="bandeau card border-0 shadow-sm rounded-4 mb-3">
    <div class="card-body py-3">
      <div class="d-flex flex-wrap align-items-center gap-3">
        <div class="avatar">{{ initiales }}</div>
        <div class="flex-grow-1">
          <div class="fs-5 fw-bold">{{ patient.prenom }} {{ patient.nom }}
            <router-link v-if="patient.id" :to="{ name: 'information_personnelle', params: { id: patient.id } }" class="small fw-normal ms-2" target="_blank">
              <i class="bi bi-folder2-open"></i> Dossier
            </router-link>
          </div>
          <div class="small text-muted d-flex flex-wrap gap-3">
            <span><i class="bi bi-hash"></i>{{ patient.numeroDossier || '—' }}</span>
            <span>{{ sexe }}<span v-if="patient.ageAffiche || patient.age"> · {{ patient.ageAffiche || patient.age }}</span>
              <span v-if="patient.mineur" class="badge bg-info-subtle text-info-emphasis ms-1">Mineur</span></span>
            <span v-if="patient.telephone"><i class="bi bi-telephone"></i> {{ patient.telephone }}</span>
            <span v-if="responsable"><i class="bi bi-people"></i> {{ responsable.lienLibelle }} : {{ responsable.nomComplet }}<span v-if="responsable.telephone"> · {{ responsable.telephone }}</span></span>
            <span v-if="accompagnant" class="text-success"><i class="bi bi-person-walking"></i> Amené par {{ accompagnant.nom }}<span v-if="accompagnant.lien"> ({{ accompagnant.lien }})</span><span v-if="accompagnant.telephone"> · {{ accompagnant.telephone }}</span></span>
            <span v-if="(patient.elementsManquants || []).length" class="text-warning-emphasis" :title="patient.elementsManquants.join(', ')"><i class="bi bi-exclamation-circle"></i> Dossier à compléter</span>
            <span v-if="patient.groupeSanguin"><i class="bi bi-droplet-fill text-danger"></i> {{ patient.groupeSanguin }}</span>
            <span v-if="patient.profession"><i class="bi bi-briefcase"></i> {{ patient.profession }}</span>
            <span v-if="patient.assurance" class="text-primary"><i class="bi bi-shield-check"></i> {{ patient.assurance.nom }}<span v-if="patient.assurance.taux"> ({{ patient.assurance.taux }} %)</span></span>
          </div>
        </div>
      </div>

      <div class="row g-2 mt-2">
        <div class="col-md-6">
          <div class="zone" :class="allergies ? 'zone-danger' : 'zone-neutre'">
            <div class="d-flex justify-content-between align-items-center">
              <span class="fw-semibold"><i class="bi bi-exclamation-octagon me-1"></i>Allergies</span>
              <button v-if="modifiable && !edition.allergies" type="button" class="btn btn-sm btn-link p-0" @click="edition.allergies = true">Modifier</button>
            </div>
            <textarea v-if="edition.allergies" :value="allergies" class="form-control form-control-sm mt-1" rows="2" placeholder="Ex. pénicilline, sulfamides — ou « Aucune connue »" @input="$emit('update:allergies', $event.target.value)"></textarea>
            <div v-else class="small">{{ allergies || 'Non renseignées — à demander au patient' }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="zone zone-neutre">
            <div class="d-flex justify-content-between align-items-center">
              <span class="fw-semibold"><i class="bi bi-journal-medical me-1"></i>Antécédents</span>
              <button v-if="modifiable && !edition.antecedents" type="button" class="btn btn-sm btn-link p-0" @click="edition.antecedents = true">Modifier</button>
            </div>
            <textarea v-if="edition.antecedents" :value="antecedents" class="form-control form-control-sm mt-1" rows="2" placeholder="Médicaux, chirurgicaux, obstétricaux, familiaux, traitements au long cours…" @input="$emit('update:antecedents', $event.target.value)"></textarea>
            <div v-else class="small texte">{{ antecedents || 'Non renseignés' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BandeauPatient',
  props: { patient: { type: Object, default: () => ({}) }, accompagnant: { type: Object, default: null }, allergies: { type: String, default: '' }, antecedents: { type: String, default: '' }, modifiable: Boolean },
  emits: ['update:allergies', 'update:antecedents'],
  data() {
    return { edition: { allergies: false, antecedents: false } }
  },
  computed: {
    initiales() {
      return ((this.patient.prenom || ' ')[0] + (this.patient.nom || ' ')[0]).toUpperCase().trim() || '?'
    },
    responsable() {
      const r = this.patient.responsables || []
      return r.find(x => x.principal) || r[0] || null
    },
    sexe() {
      const g = String(this.patient.genre || '').toLowerCase()
      return g.startsWith('m') ? 'Homme' : g.startsWith('f') ? 'Femme' : '—'
    },
  },
}
</script>

<style scoped>
.avatar { width: 48px; height: 48px; border-radius: 50%; background: #e7f0ff; color: #0d6efd; display: flex; align-items: center; justify-content: center; font-weight: 700; }
.zone { border-radius: 8px; padding: 8px 10px; height: 100%; }
.zone-danger { background: #fff1f2; border: 1px solid #f5c2c7; color: #842029; }
.zone-neutre { background: #f8f9fb; border: 1px solid #e3e8ef; }
.texte { white-space: pre-line; }
</style>
